import React, { createContext, useContext, useEffect, useCallback, useState } from "react";
import { toast } from "react-toastify";
import { apiPublica } from "../services/api";

const RestauranteContext = createContext();

export const useRestaurante = () => {
  return useContext(RestauranteContext);
};

export const RestauranteProvider = ({ children }) => {
  const [restaurantes, setRestaurantes] = useState([]);
  const [originalRestaurantes, setOriginalRestaurantes] = useState([]);
  const [restauranteId, setRestauranteId] = useState(null);
  // Começa carregando para a lista não aparecer vazia antes da primeira resposta.
  const [carregandoRestaurantes, setCarregandoRestaurantes] = useState(true);
  const [erroRestaurantes, setErroRestaurantes] = useState(false);
 
  const fetchRes = useCallback(async () => {
    setCarregandoRestaurantes(true);
    try {
      const data = await apiPublica.listarRestaurantes();
      setRestaurantes(data?.content || []);
      setOriginalRestaurantes(data?.content || []);
      setErroRestaurantes(false);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setErroRestaurantes(true);
    } finally {
      setCarregandoRestaurantes(false);
    }
  }, []);

  const buscarRestaurantes = (termo) => {
    if (!termo) {
      setRestaurantes(originalRestaurantes); // Restaura a lista original
      return;
    }
    const termoNormalizado = termo.toLowerCase();
    const restauranteFiltrado = originalRestaurantes.filter((restaurante) =>
      restaurante.nome.toLowerCase().includes(termoNormalizado)
    );
    setRestaurantes(restauranteFiltrado);
  };

  const editRestaurante = async (restauranteAtualizado) => {
    try {
      const user = sessionStorage.getItem("user"); // Obter o token
      const {access_token} = JSON.parse(user)
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${restauranteAtualizado.id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authentication': access_token,
        },
        body: JSON.stringify(restauranteAtualizado),
      });
  
      if (!response.ok) throw new Error("Erro ao atualizar o restaurante");
    } catch (error) {
      console.error("Erro ao editar restaurante:", error);
    } finally {
    }
  };

  const deleteRestaurante = async (id) => {
    const toastId = toast.loading("Excluindo restaurante...");
    try {
      const user = sessionStorage.getItem("user");
      const {access_token} = JSON.parse(user);
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/restaurantes/${id}`, {
        method: "DELETE",
        headers: {
          'Authentication': access_token,
        },
      });

      if (!response.ok) throw new Error("Erro ao excluir o restaurante");

      setRestaurantes((prev) => prev.filter((restaurante) => restaurante.id !== id));
      toast.update(toastId, {
        render: "Restaurante excluído com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Erro ao excluir restaurante:", error);
      toast.update(toastId, {
        render: "Erro ao excluir o restaurante!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
    }
  };

  return (
    <RestauranteContext.Provider value={{ restaurantes, carregandoRestaurantes, erroRestaurantes, deleteRestaurante, restauranteId, setRestauranteId, editRestaurante, fetchRes, buscarRestaurantes }}>
      {children}
    </RestauranteContext.Provider>
  );
};